(function () {
  function scrollTab(root, tabs, index) {
    if (window.innerWidth > 768) return;
    var btn = tabs[index];
    var bar = root.querySelector(".v3-mcs__tabs");
    if (!btn || !bar) return;
    var left =
      bar.scrollLeft +
      (btn.getBoundingClientRect().left - bar.getBoundingClientRect().left) +
      btn.offsetWidth / 2 -
      bar.clientWidth / 2;
    bar.scrollTo({
      left: Math.max(0, Math.min(left, bar.scrollWidth - bar.clientWidth)),
      behavior: "smooth"
    });
  }

  function setActive(tabs, index) {
    tabs.forEach(function (btn, i) {
      var on = i === index;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-selected", on ? "true" : "false");
    });
  }

  function bindCompare(root, swiper) {
    root.querySelectorAll("[data-mcs-compare]").forEach(function (el) {
      var clearEl = el.querySelector("[data-mcs-compare-clear]");
      var barEl = el.querySelector("[data-mcs-compare-bar]");
      if (!clearEl || !barEl) return;
      var dragging = false;

      function setPos(percent) {
        var next = Math.max(0, Math.min(100, percent));
        barEl.style.left = next + "%";
        clearEl.style.clipPath = "inset(0 " + (100 - next) + "% 0 0)";
      }

      function fromX(clientX) {
        var rect = el.getBoundingClientRect();
        if (!rect.width) return;
        setPos(((clientX - rect.left) / rect.width) * 100);
      }

      function start(clientX) {
        dragging = true;
        if (swiper) {
          swiper.allowTouchMove = false;
          if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
        }
        fromX(clientX);
      }

      function end() {
        if (!dragging) return;
        dragging = false;
        if (!swiper) return;
        swiper.allowTouchMove = true;
        if (swiper.autoplay) swiper.autoplay.start();
      }

      barEl.addEventListener("mousedown", function (event) {
        event.preventDefault();
        event.stopPropagation();
        start(event.clientX);
      });
      barEl.addEventListener(
        "touchstart",
        function (event) {
          if (!event.touches.length) return;
          event.preventDefault();
          event.stopPropagation();
          start(event.touches[0].clientX);
        },
        { passive: false }
      );
      window.addEventListener("mousemove", function (event) {
        if (dragging) fromX(event.clientX);
      });
      window.addEventListener(
        "touchmove",
        function (event) {
          if (dragging && event.touches.length) fromX(event.touches[0].clientX);
        },
        { passive: true }
      );
      window.addEventListener("mouseup", end);
      window.addEventListener("touchend", end);
    });
  }

  function bindRoot(root) {
    if (!root || root.getAttribute("data-mcs-bound") === "1") return;
    root.setAttribute("data-mcs-bound", "1");
    var tabs = Array.from(root.querySelectorAll("[data-mcs-tab]"));
    var el = root.querySelector("[data-mcs-swiper]");
    if (!el || typeof Swiper === "undefined") return;

    if (el.swiper) el.swiper.destroy(true, true);

    var delay = Number(root.getAttribute("data-autoplay-delay") || 5) * 1000;
    var opts = {
      slidesPerView: 1,
      speed: 500,
      watchOverflow: true,
      on: {
        slideChange: function (swiper) {
          setActive(tabs, swiper.activeIndex);
          scrollTab(root, tabs, swiper.activeIndex);
        }
      }
    };
    if (root.getAttribute("data-autoplay") === "true" && tabs.length > 1) {
      opts.autoplay = { delay: delay, disableOnInteraction: false };
    }

    opts.autoplay = false;

    var swiper = new Swiper(el, opts);
    bindCompare(root, swiper);
    tabs.forEach(function (btn, index) {
      btn.addEventListener("click", function () {
        swiper.slideTo(index);
      });
    });
  }

  document.querySelectorAll("[data-mcs-root]").forEach(bindRoot);
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-mcs-root]");
    if (!root) return;
    root.removeAttribute("data-mcs-bound");
    bindRoot(root);
  });
})();
